document.addEventListener('DOMContentLoaded', () => {
  handleClickEvent();
});
document.addEventListener('on:line-item:change', () => {
  handleClickEvent();
});

window.addEventListener('resize', () => {
  loadAccordionRetailer();
});

const globalCartItems = [];

function loadAccordionRetailer() {
  const modalRetailer = document.querySelector('.modal-sellers table');
  if (modalRetailer) {
    const retailerDetails = modalRetailer.querySelectorAll('details');
    retailerDetails.forEach((detail) => {
      if (window.matchMedia("(min-width: 769px)").matches) {
        detail.setAttribute('open', '');
      } else if (!detail.classList.contains('open')) {
        detail.removeAttribute('open');
      }
    });
  }
}

function handleClickEvent() {
  const btnModal = document.querySelector('#cart-submit-btn');

  if (btnModal) {
    btnModal.addEventListener('click', (e) => {
      e.preventDefault();

      const cartItemsContainer = document.querySelector('#cart-items-data');
      if (!cartItemsContainer) {
        return;
      }

      const cartItems = cartItemsContainer.querySelectorAll('li');
      if (cartItems.length === 0) {
        return;
      }

      let uri = '';
      cartItems.forEach((cartItem, index) => {
        const gtin = cartItem.getAttribute('data-barcode');
        const quantity = cartItem.getAttribute('data-quantity');
        const name = cartItem.getAttribute('data-name');

        uri += `&gtin[${index}]=${gtin}&qt[${index}]=${quantity}`

        globalCartItems[gtin] = name;
      });

      const url = 'https://www.nexmart.com/api/retailconnect/retailers?services=cart&supplier=facom_fr' + uri;
      const headers = new Headers();
      headers.set('Authorization', 'Basic ZmFjb21fZnJAbmV4bWFydC5jb206QXN0ZFhEN214Yg==');

      const modal = document.querySelector('#nexmart-modal');
      if (!modal) {
        return;
      }

      const modalContent = modal.querySelector('.modal__content');

      fetch(url, {
        method: 'GET',
        headers: headers,
      }).then(response => {
        if (response.ok) {
          return response.json();
        }

        throw new Error('Une erreur est survenue, veuillez nous excuser pour la gêne occasionnée. N’hésitez pas à vous rapprocher de votre distributeur de proximité');
      })
        .then(json => {
          const error = json.error;
          if (error && json.retailers.length === 0) {
            handleError(error, modalContent);
            return;
          }

          let retailers = json.retailers;
          if (retailers.length === 0) {
            handleError(new Error('Malheureusement, aucun distributeur ne dispose de ces produits'), modalContent);
            return;
          }

          const retailersList = modal.querySelector('#retailers-list');
          if (!retailersList) {
            return;
          }

          const retailersTable = createRetailersTable(retailers);
          retailersList.appendChild(retailersTable);
          loadAccordionRetailer();

          const retailersNumber = modal.querySelector('#retailers-number span');
          retailersNumber.innerHTML = retailers.length;
        })
        .catch((error) => {
          handleError(error, modalContent);
        })
        .finally(() => {
          modal.setAttribute('open', 'true');
        })
    });
  }
}

function createRetailersTable(retailers) {
  cleanRetailersList();

  retailers = retailers.sort((a,b) => b.rank - a.rank);

  const retailersTable = document.createElement('table');
  retailersTable.setAttribute('id', 'retailers-table');
  const tbody = document.createElement('tbody');
  const headers = createHeaders();

  retailers.forEach((retailer) => {
    const retailerLine = createRetailerLine(retailer);
    tbody.appendChild(retailerLine);
  });
  retailersTable.appendChild(headers);
  retailersTable.appendChild(tbody);

  return retailersTable;
}

function createHeaders() {
  const tr = document.createElement('tr');
  const headers = ['Distributeur', 'Produits', 'Mode de livraison', 'Moyens de paiement', ''];

  headers.forEach((header) => {
    const th = document.createElement('th');
    th.textContent = header;
    tr.appendChild(th);
  });

  return tr;
}

function createRetailerLine(retailer) {
  const tr = document.createElement('tr');

  const logo = document.createElement('td');
  const img = document.createElement('img');
  img.setAttribute('src', retailer.logoUrl);
  img.setAttribute('height', '100');
  img.setAttribute('width', '100');
  logo.appendChild(img);
  tr.appendChild(logo);

  const retailerProducts = retailer.products;
  if (retailerProducts.length > 0) {
    const td = document.createElement('td');

    const retailerProductsDisclosure = document.createElement('details-disclosure');
    const retailerProductsDetail = document.createElement('details');
    retailerProductsDetail.classList.add('open');
    retailerProductsDetail.setAttribute('open', '');
    const retailerProductsSummary = document.createElement('summary');
    retailerProductsSummary.innerHTML = 'Détail des produits disponibles';
    retailerProductsDetail.appendChild(retailerProductsSummary);

    const productList = document.createElement('ul');
    retailerProducts.forEach((product) => {
      const productLi = document.createElement('li');

      if (labelsToExclude(product.stock)) {
        return;
      }

      const mappedStock = mapLabels(product.stock);

      if (product.supplierPid) {
        productLi.innerHTML = `<span class="product-name">${globalCartItems[product.gtin] ?? ''}</span> - <span class="product-ref">${product.supplierPid}</span> - <span class="stock-${product.stock.toLowerCase()}">${mappedStock}</span>`;
      } else if (product.error && product.error.code === 'UNKNOWN_PRODUCT') {
        productLi.innerHTML = `<span class="product-name">${globalCartItems[product.requested.gtin] ?? ''}</span> - <span class="product-ref">${product.requested.gtin}</span> - <span class="stock-not-available">Non disponible</span>`;
      } else {
        return;
      }

      productList.appendChild(productLi);
    })

    retailerProductsDetail.appendChild(productList);
    retailerProductsDisclosure.appendChild(retailerProductsDetail);
    td.appendChild(retailerProductsDisclosure);
    tr.appendChild(td);
  }

  const retailerDeliveryTypes = retailer.deliveryTypes;
  if (retailerDeliveryTypes.length > 0) {
    const td = document.createElement('td');

    const deliveryTypesDisclosure = document.createElement('details-disclosure');
    const deliveryTypesDetail = document.createElement('details');
    const deliveryTypesSummary = document.createElement('summary');
    deliveryTypesSummary.innerHTML = 'Mode de livraison';
    deliveryTypesDetail.appendChild(deliveryTypesSummary);

    const deliveryTypesList = document.createElement('ul');
    retailerDeliveryTypes.forEach((deliveryType) => {
      const deliveryTypeLi = document.createElement('li');

      if (labelsToExclude(deliveryType)) {
        return;
      }

      deliveryTypeLi.textContent = mapLabels(deliveryType);

      deliveryTypesList.appendChild(deliveryTypeLi);
    })

    deliveryTypesDetail.appendChild(deliveryTypesList);
    deliveryTypesDisclosure.appendChild(deliveryTypesDetail);
    td.appendChild(deliveryTypesDisclosure);
    tr.appendChild(td);
  }

  const retailerPayments = retailer.payment;
  if (retailerPayments.length > 0) {
    const td = document.createElement('td');

    const retailerPaymentsDisclosure = document.createElement('details-disclosure');
    const retailerPaymentsDetail = document.createElement('details');
    const retailerPaymentsSummary = document.createElement('summary');
    retailerPaymentsSummary.innerHTML = 'Moyens de paiement';
    retailerPaymentsDetail.appendChild(retailerPaymentsSummary);

    const paymentsList = document.createElement('ul');
    retailerPayments.forEach((payment) => {
      const paymentLi = document.createElement('li');

      if (labelsToExclude(payment)) {
        return;
      }

      paymentLi.textContent = mapLabels(payment);

      paymentsList.appendChild(paymentLi);
    })

    retailerPaymentsDetail.appendChild(paymentsList);
    retailerPaymentsDisclosure.appendChild(retailerPaymentsDetail);
    td.appendChild(retailerPaymentsDisclosure);
    tr.appendChild(td);
  }

  const retailerDeepLink = retailer.cartDeeplink;
  const td = document.createElement('td');
  const link = document.createElement('a');
  link.textContent = 'Ajouter au panier';
  link.setAttribute('href', retailerDeepLink);
  link.setAttribute('target', '_blank');
  link.setAttribute('class', 'btn btn--secondary');
  td.appendChild(link);
  tr.appendChild(td);

  return tr;
}

function handleError(error, modalContent) {
  if (!modalContent) {
    return;
  }

  const errorsContainer = modalContent.querySelector('#errors-container');
  if (!errorsContainer) {
    return;
  }

  cleanRetailersList();

  errorsContainer.innerHTML = '';
  errorsContainer.classList.add('alert', 'bg-error-bg', 'mb-10');

  const errorContainer = document.createElement('li');
  if (error.message !== null) {
    if (error.code === 'UNKNOWN_PRODUCT') {
      errorContainer.textContent = 'Une erreur est survenue, veuillez nous excuser pour la gêne occasionnée. N’hésitez pas à vous rapprocher de votre distributeur de proximité';
    } else {
      errorContainer.textContent = error.message;
    }
  } else {
    errorContainer.textContent = 'Une erreur est survenue, veuillez nous excuser pour la gêne occasionnée. N’hésitez pas à vous rapprocher de votre distributeur de proximité';
  }

  errorsContainer.append(errorContainer);
}

function cleanRetailersList() {
  const modal = document.querySelector('#nexmart-modal');
  if (!modal) {
    return;
  }

  const retailersList = modal.querySelector('#retailers-list');
  if (!retailersList) {
    return;
  }

  const retailersTable = retailersList.querySelector('#retailers-table');
  if (retailersTable) {
    retailersTable.remove();
  }

  const retailersNumber = modal.querySelector('#retailers-number span');
  retailersNumber.innerHTML = 0;
}

function labelsToExclude(label) {
  const labelsToExclude = [
    // Payment
    'paymentInAdvance',
    'debit',
    'eCard',
    'cash',
    'mobile',
    'payment1',
    'payment2',
    'payment3',
    'payment4',
    'ideal',
    'amazonPay',
  ];

  return labelsToExclude.includes(label);
}

function mapLabels(label) {
  const labelsMapping = {
    // Stock
    'low': 'En stock',
    'full': 'En stock',
    'empty': 'En rupture',
    'availableOnRequest': 'Disponible sur demande',

    // Delivery
    'deliveryToConstruction': 'Livraison sur chantier',
    'express': 'Livraison express',
    'homeDelivery': 'Livraison à domicile',
    'collectionPoint': 'Livraison en point relais',
    'normal': 'Livraison standard',
    'pickup': 'Retrait magasin',

    // Payment
    'creditcard': 'Carte bancaire',
    'invoice': 'Facture clients en compte',
    'paymentInAdvance': 'Accompte',
    'cash': 'Liquide',
    'sofortUeberweisung': 'Virement bancaire'
  };

  if (labelsMapping[label] !== undefined) {
    return labelsMapping[label];
  }

  return label;
}
